import type { RefObject } from 'react';

export const getRowHeights = (
  carouselRef: RefObject<HTMLDivElement>,
  rows: number
): number[] => {
  const heightRows = Array.from(Array(rows).fill(0));

  carouselRef.current?.childNodes.forEach((column) => {
    column.childNodes.forEach((row, i) => {
      if (!row.firstChild) {
        return;
      }

      const element = row.firstChild as Element;

      // resetting the height before getting the current height of the content
      // without this, you won't be able to change the height of the cell with dynamically changing content in it
      (row as HTMLElement).style.height = 'auto';

      const { height } = element.getBoundingClientRect();

      if (height > heightRows[i]) {
        heightRows[i] = height;
      }
    });
  });

  return heightRows;
};
